import React, { PropTypes, Component } from 'react';
import styles from './Styles';
import { IconButton, RaisedButton } from 'material-ui';
import TaskResultList from './TaskResultList';
import RadioTaskResult from './RadioTaskResult';
import * as SvgIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import Message from 'services/Message';
import { CourseActions, QuizActions } from 'actions';
import Embed from 'components/Page/Module/Embed';
import { translate as _l } from 'oxygen-i18n';

const classes = oxygenCss({
  comment: {
    marginLeft: '10px',
    background: '#fff0cb',
    padding: '5px 10px',
    width: 'calc(100% - 40px)'
  }
});

export default class RadioTask extends Component {
  constructor(props) {
    super(props);
    CourseActions.answerTaskComplete.listen(
      props.isQuiz ? QuizActions.updateAnswer : () => { }
    );
    let choice = null;
    if (this.props.answered) {
      choice = this.props.answered[0];
    }
    this.state = {
      choice,
      hasAnswered: false
    };
  }

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  choose(index) {
    if (this.state.choice !== index) {
      this.setState({ choice: index });
    }
  }

  answer = () => {
    if (this.state.choice !== null) {
      let { pageModuleId, id, taskId } = this.props;

      this.setState({ hasAnswered: true });

      CourseActions.answerTask(taskId || id, pageModuleId, {
        value: [this.state.choice]
      });

      if (this.props.isQuiz && this.props.displayNextQuizQuestion) {
        QuizActions.next();
      }
      this.props.gaTracking && this.props.gaTracking();
    } else {
      Message.error(this.context.getIntlMessage('tasks.pleaseChooseOne'));
    }
  }

  renderAnswerControls() {
    return (
      <div style={styles.answerControls}>
        <RaisedButton
          onTouchTap={this.answer}
          fullWidth={true}
          backgroundColor={this.props.themeColor}
          labelColor="#FFF"
          label={this.context.getIntlMessage('tasks.answer')}
        />
      </div>
    );
  }

  renderTaskResultList() {
    const {
      showTaskResultOnAnswer,
      caption,
      taskResults,
      correctResponse,
      canGrade,
      taskId,
      reader,
    } = this.props;

    let results = taskResults;

    if (showTaskResultOnAnswer) {
      if (!this.state.hasAnswered || !taskResults) {
        return null;
      }

      const lastAnswer = taskResults[taskResults.length - 1];
      results = [lastAnswer];
    }

    return (
      <TaskResultList
        reader={reader}
        correctResponse={correctResponse}
        ListElement={RadioTaskResult}
        results={results}
        choices={caption.items}
        canGrade={canGrade}
        taskId={taskId}
        removeAnimation={showTaskResultOnAnswer}
      />
    );
  }

  render() {
    let {
      caption,
      captionFiles,
      taskResults,
      correctResponse,
      canAnswer,
      file,
      reader,
      isQuiz,
      canEdit
    } = this.props;
    caption = caption || {};
    caption.items = caption.items || [];
    let main = isQuiz
      ? caption.main || this.context.getIntlMessage('tasks.defineQuestion')
      : caption.main || this.context.getIntlMessage('tasks.defineTask');
    let choices = caption.items.map((item, index) => {
      let icon;
      if (canAnswer) {
        if (index === this.state.choice) {
          icon = (
            <IconButton
              style={styles.radio}
              onTouchTap={this.choose.bind(this, index)}
            >
              <SvgIcons.ToggleRadioButtonChecked
                color={Colors.Colors.green[800].material}
              />
            </IconButton>
          );
        } else {
          icon = (
            <IconButton
              style={styles.radio}
              onTouchTap={this.choose.bind(this, index)}
            >
              <SvgIcons.ToggleRadioButtonUnchecked />
            </IconButton>
          );
        }
      } else {
        icon = <SvgIcons.ToggleRadioButtonUnchecked style={styles.radio} />;
      }

      return (
        <div style={styles.label} key={index}>
          {icon}
          {item}
        </div>
      );
    });
    let answerControls;
    if (canAnswer && reader && !canEdit) {
      answerControls = this.renderAnswerControls();
    }
    let external = null;
    try {
      external = JSON.parse(
        (this.props.frontend && this.props.frontend[0]) || null
      );
    } catch (err) { }
    let fileType = null;
    let File = file
      ? file
      : external
        ? { ...external, type: 'external' }
        : captionFiles && captionFiles[0];
    let ext;
    if (File && File.type.includes('image')) {
      ext = File.type.replace(/\/(jpeg|jpg|png|webp)/g, '');
    } else if (File && File.type.includes('video')) {
      ext = File.type.replace(/\/(mp4|mov)/g, '');
    } else if (File && File.type.includes('audio')) {
      ext = File.type.replace(/\/(mp4|x-m4a|mp3)/g, '');
    } else if (File && File.type === 'external') {
      ext = 'external';
    }
    switch (ext) {
      case 'video':
        fileType = (
          <video style={{ width: '100%' }} controls alt={File.name}>
            <source
              src={File.url.includes('.mp4') ? File.url : File.url + '.mp4'}
              type={File.type}
            />
          </video>
        );
        break;

      case 'image':
        fileType = (
          <img style={{ width: '100%' }} src={File.url} alt={File.name} />
        );
        break;

      case 'audio':
        fileType = (
          <audio controls style={{ width: '100%' }}>
            <source src={File.url} type={File.type} />
          </audio>
        );
        break;

      case 'external':
        fileType = <Embed provider={File.provider} id={File.id} />;
        break;

      default:
        break;
    }

    return (
      <div>
        {File && fileType}
        <div style={styles.question}>{main}</div>
        <div style={styles.choices}>{choices}</div>
        {answerControls}
        {this.renderTaskResultList()}
        {caption &&
          caption.comment &&
          taskResults &&
          taskResults[taskResults.length - 1] &&
          !!diff(
            taskResults[taskResults.length - 1].body.value,
            correctResponse.value
          ).length && (
            <div className={classes.comment}>
              <h5>{_l`comment`}</h5>
              <i>{caption.comment}</i>
            </div>
          )}
      </div>
    );
  }
}

function diff(a, b) {
  return b.filter(i => {
    return a.indexOf(i) < 0;
  });
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/RadioTask.js